import burger from '../components/burger/script.js'
import lazyLoad from '../components/lazy_load/script.js'
import gameFrame from '../components/banner-game/script.js'
import refInit from '../components/ref/script.js'
burger()
lazyLoad()
gameFrame()
refInit()